import React, { useState } from 'react';
import { QuantityInput } from 'telstra-ui/components/quantity/quantity';
import Pagination from 'telstra-ui/components/pagination/Pagination';
import TextWithTooltip from '../../../../components/text-with-tooltip/text-with-tooltip';
import { Mobile, Desktop } from '../../../../app-responsive';
import { formatNumber } from '../../../../app-actions';
import './service-details.css';

const ServiceDetails = (props) => {
  const {
    authorableContent: {
      serviceDetails,
      serviceNumber,
      numberRanges,
      sipChannels,
      sipChannelToolTip,
      outboundCalls,
      inboundCalls,
      migrateToTipt,
      migrateToLiberateMobile,
      serviceNumberToolTip,
      numberRangesToolTip,
      outboundCallsToolTip,
      inboundCallsToolTip,
      migrateToTiptToolTip,
      migrateToLiberateMobileToolTip,
      outboundCallsShow,
      inboundCallsShow,
    },
    siteServiceDetails,
    handleServiceQuanitityChange,
    quantityData,
    siteId,
    currentPage,
    pageChangeHandler,
  } = props;

  const [pageSize, setPageSize] = useState(5);
  const numberOfPages = Math.ceil(siteServiceDetails.length / pageSize);
  const pageSizeOptions = ['5', '10', '20'];
  const totalRecords = siteServiceDetails.length;

  const showInBound = inboundCallsShow.toLowerCase() === 'y';
  const showOutBound = outboundCallsShow.toLowerCase() === 'y';


  const onPageChange = (pageNumber) => {
    pageChangeHandler(pageNumber);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
  };

  const detailsTableFlex = siteServiceDetails.slice(currentPage * pageSize, pageSize * (currentPage + 1)).map(serviceItem => (
    <div className="d-flex flex-row align-content-stretch item-flex-row" key={`${serviceItem.serviceNumber}`}>
      <div className="ri-service-width-header">
        {serviceItem.serviceNumber}
      </div>
      <div className="ri-number-ranges-header">
        {serviceItem.numberRanges.map(range => (
          <div className="number-range">{range}</div>
        ))}
      </div>
      <div className={`${showOutBound === false && showInBound === false ? 'ri-number-normal-special' : 'ri-number-normal'}`}>
        {formatNumber(serviceItem.sipChannels)}
      </div>
      {showOutBound &&
        <div className="ri-number-normal">
          {formatNumber(serviceItem.avgOutboundCalls)}
        </div>
      }
      {showInBound &&
        <div className="ri-number-normal">
          {formatNumber(serviceItem.avgInboundCalls)}
        </div>
      }

      <div className="ri-number-ranges-header">
        <QuantityInput
          className="quantity-tipt"
          id={`${siteId}-${serviceItem.serviceNumber}-tipt`}
          index={`${siteId}-${serviceItem.serviceNumber}-tipt`}
          value={quantityData[`${siteId}-${serviceItem.serviceNumber}-tipt`] !== undefined ?
            quantityData[`${siteId}-${serviceItem.serviceNumber}-tipt`] : 0}
          min={0}
          max={1000}
          enable
          step={1}
          onChange={handleServiceQuanitityChange}
        />
      </div>

      <div className="ri-number-ranges-header">
        <QuantityInput
          className="quantity-liberate"
          id={`${siteId}-${serviceItem.serviceNumber}-liberate`}
          index={`${siteId}-${serviceItem.serviceNumber}-liberate`}
          value={quantityData[`${siteId}-${serviceItem.serviceNumber}-liberate`] !== undefined ?
            quantityData[`${siteId}-${serviceItem.serviceNumber}-liberate`] : 0}
          min={0}
          max={1000}
          enable
          step={1}
          onChange={handleServiceQuanitityChange}
        />
      </div>

    </div>
  ));

  const mobileViewData = siteServiceDetails.slice(currentPage * pageSize, pageSize * (currentPage + 1)).map(serviceItem => (
    <React.Fragment>
      <hr />
      <div className="row item-div item-heading">
        <div className="col-6 heading16">
          {serviceNumber}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="service-number-tooltip"
            toolTipText={serviceNumberToolTip}
          />
        </div>
        <div className="col-6 heading16">
          {numberRanges}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="number-ranges-tooltip"
            toolTipText={numberRangesToolTip}
          />
        </div>
      </div>
      <div className="row item-div item-data">
        <div className="col-6">
          {serviceItem.serviceNumber}
        </div>
        <div className="col-6">
          {serviceItem.numberRanges.map(range => (
            <div className="number-range">{range}</div>
          ))}
        </div>
      </div>
      <div className="row item-div item-heading">
        {showOutBound &&
          <div className="col-6 heading16">
            {outboundCalls}
            <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="outbound-calls-tooltip"
              toolTipText={outboundCallsToolTip}
            />
          </div>
        }
        {showInBound &&
          <div className="col-6 heading16">
            {inboundCalls}
            <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="inbound-calls-tooltip"
              toolTipText={inboundCallsToolTip}
            />
          </div>
        }
      </div>
      <div className="row item-div item-data">
        {showOutBound &&
          <div className="col-6">
            {serviceItem.avgOutboundCalls}
          </div>
        }
        {showInBound &&
          <div className="col-6">
            {serviceItem.avgInboundCalls}
          </div>
        }
      </div>
      <div className="row item-div item-heading">
        <div className="col-6 heading16">
          {migrateToTipt}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="migrate-tipt-tooltip"
            toolTipText={migrateToTiptToolTip}
          />
        </div>
        <div className="col-6 heading16">
          {migrateToLiberateMobile}
          <TextWithTooltip
            text={<i className="td-icon icon-help" />}
            textClassName="help-icon-container"
            id="migrate-liberate-tooltip"
            toolTipText={migrateToLiberateMobileToolTip}
          />
        </div>
      </div>
      <div className="row item-div item-data text-center">
        <div className="col-6">
          <QuantityInput
            className="quantity-tipt"
            id={`${siteId}-${serviceItem.serviceNumber}-tipt`}
            index={`${siteId}-${serviceItem.serviceNumber}-tipt`}
            value={quantityData[`${siteId}-${serviceItem.serviceNumber}-tipt`] !== undefined ?
              quantityData[`${siteId}-${serviceItem.serviceNumber}-tipt`] : 0}
            min={0}
            max={1000}
            enable
            step={1}
            onChange={handleServiceQuanitityChange}
          />
        </div>
        <div className="col-6">
          <QuantityInput
            className="quantity-liberate"
            id={`${siteId}-${serviceItem.serviceNumber}-liberate`}
            index={`${siteId}-${serviceItem.serviceNumber}-liberate`}
            value={quantityData[`${siteId}-${serviceItem.serviceNumber}-liberate`] !== undefined ?
              quantityData[`${siteId}-${serviceItem.serviceNumber}-liberate`] : 0}
            min={0}
            max={1000}
            enable
            step={1}
            onChange={handleServiceQuanitityChange}
          />
        </div>
      </div>
    </React.Fragment>
  ));

  return (
    <div className="service-details-section">
      <span className="heading20">{serviceDetails}</span>
      <Desktop>
        <div className="ri-scroll-table">
          <div className="d-flex flex-row align-content-stretch heading16 item-flex-row-header">
            <div className="ri-service-width-header">
              {serviceNumber}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="service-number-tooltip"
                toolTipText={serviceNumberToolTip}
              />
            </div>
            <div className="ri-number-ranges-header">
              {numberRanges}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="number-ranges-tooltip"
                toolTipText={numberRangesToolTip}
              />
            </div>

            <div className="ri-number-normal">
              {sipChannels}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="sip-channels-tooltip"
                toolTipText={sipChannelToolTip}
              />
            </div>

            {showOutBound &&
            <div className="ri-number-normal">
              {outboundCalls}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="outbound-calls-tooltip"
                toolTipText={outboundCallsToolTip}
              />
            </div>
            }

            {showInBound &&
            <div className="ri-number-normal">
              {inboundCalls}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="inbound-calls-tooltip"
                toolTipText={inboundCallsToolTip}
              />
            </div>
            }

            <div className="ri-number-ranges-header">
              {migrateToTipt}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="migrate-tipt-tooltip"
                toolTipText={migrateToTiptToolTip}
              />
            </div>

            <div className="ri-number-ranges-header">
              {migrateToLiberateMobile}
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="migrate-liberate-tooltip"
                toolTipText={migrateToLiberateMobileToolTip}
              />
            </div>


          </div>
          {detailsTableFlex}
        </div>


      </Desktop>
      <Mobile>
        {mobileViewData}
      </Mobile>
      <Pagination
        pages={numberOfPages}
        pageSize={pageSize}
        pageSizeOptions={pageSizeOptions}
        totalRecordLength={totalRecords}
        restorePageNumber={0}
        page={currentPage}
        canNext={(currentPage < numberOfPages - 1)}
        canPrevious={currentPage !== 0}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  );
};

export default ServiceDetails;
